import { Box } from '@workos-inc/design-system';
export const PageBackground = () => <Box inset="0" position="absolute" style={{
  zIndex: -1
}} data-sentry-element="Box" data-sentry-component="PageBackground" data-sentry-source-file="page-background.tsx">
    <Box style={{
    inset: 0,
    position: 'fixed',
    backgroundImage: 'linear-gradient(to bottom right, var(--purple-1), var(--gray-1), var(--color-background))'
  }} data-sentry-element="Box" data-sentry-source-file="page-background.tsx" />
    <Box style={{
    top: 0,
    width: 700,
    height: 1000,
    position: 'fixed',
    transform: 'translate(-50%, -10%) rotate(30deg)',
    backgroundImage: 'radial-gradient(farthest-side, var(--purple-3), transparent)'
  }} data-sentry-element="Box" data-sentry-source-file="page-background.tsx" />
    <Box style={{
    top: 0,
    width: 400,
    height: 600,
    position: 'fixed',
    filter: 'hue-rotate(30deg)',
    transform: 'translate(-60%, 50%) rotate(-30deg)',
    backgroundImage: 'radial-gradient(farthest-side, var(--purple-3), transparent)'
  }} data-sentry-element="Box" data-sentry-source-file="page-background.tsx" />
  </Box>;